<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1rem"
    height="1rem"
    viewBox="0 0 14 15"
    fill="currentColor"
  >
    <g clip-path="url(#clip0_9725_1526)">
      <g clip-path="url(#clip1_9725_1526)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.800025 3.24961C0.800025 2.89061 1.08302 2.59961 1.43102 2.59961H8.20103L7.62602 3.90161H1.43102C1.26101 3.89846 1.09917 3.82808 0.98091 3.70589C0.862654 3.5837 0.797615 3.41964 0.800025 3.24961ZM0.800025 11.2496C0.800025 11.6096 1.08302 11.9006 1.43102 11.9016H4.82402C4.83157 11.4647 4.87337 11.029 4.94902 10.5986H1.43102C1.26083 10.6015 1.09874 10.6718 0.980265 10.794C0.861794 10.9162 0.796618 11.0804 0.799025 11.2506L0.800025 11.2496ZM1.43102 6.56361H6.45602L7.02902 5.26161H1.43102C1.2611 5.26451 1.09926 5.33466 0.980972 5.45669C0.862688 5.57872 0.797618 5.74268 0.800025 5.91261C0.800025 6.27261 1.08302 6.56361 1.43202 6.56361H1.43102ZM0.800025 8.57461C0.800025 8.93461 1.08402 9.22461 1.43202 9.22561H5.31202C5.38002 9.03061 5.45702 8.83961 5.54102 8.64961L5.86102 7.92361H1.43002C1.26001 7.92651 1.09806 7.99663 0.979621 8.11863C0.861179 8.24063 0.795884 8.40459 0.798025 8.57461H0.800025ZM13.234 4.03461L12.534 3.71161L12.809 3.09261C13.009 2.68061 13.038 2.20061 12.889 1.76561C12.8167 1.55204 12.7022 1.3552 12.5522 1.18683C12.4022 1.01847 12.2199 0.882017 12.016 0.785611C11.8152 0.691455 11.597 0.640077 11.3753 0.634741C11.1536 0.629404 10.9331 0.670225 10.728 0.754611C10.312 0.924611 9.98102 1.26261 9.81102 1.68961L6.54002 9.11661C5.94104 10.4804 5.77186 11.9943 6.05502 13.4566C6.08202 13.5966 6.17202 13.7136 6.29802 13.7726C6.42402 13.8326 6.57002 13.8246 6.68902 13.7526C7.95271 12.9985 8.94889 11.8681 9.53802 10.5196L12.058 4.80261L12.752 5.12761C12.7771 5.13995 12.7965 5.16147 12.8062 5.18772C12.8159 5.21396 12.8151 5.24293 12.804 5.26861L11.452 8.34061C11.3849 8.487 11.3774 8.65377 11.431 8.80561C11.4571 8.87994 11.4976 8.94836 11.5503 9.00689C11.603 9.06543 11.6668 9.11292 11.738 9.14661C11.8083 9.17963 11.8845 9.19791 11.9621 9.20032C12.0396 9.20272 12.1169 9.18921 12.189 9.16061C12.262 9.13117 12.3283 9.08742 12.3842 9.03195C12.44 8.97648 12.4841 8.9104 12.514 8.83761L13.866 5.76561C14.153 5.10761 13.87 4.33361 13.234 4.03461Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9725_1526">
        <rect
          width="1em"
          height="1em"
          fill="white"
          transform="translate(0 0.382568)"
        />
      </clipPath>
      <clipPath id="clip1_9725_1526">
        <rect
          width="1em"
          height="1em"
          fill="white"
          transform="translate(0 0.382568)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
